export enum SortTypeEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
